export function StepIndicator({ step, label }: { step: number; label?: string }) {
  const indicator = (
    <div className='tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-w-5 tw-h-5 tw-rounded-full tw-border-[1.5px] tw-border-black'>
      <span className='tw-text-[12px] tw-font-bold tw-text-black'>{step}</span>
    </div>
  );

  if (!label) return indicator;

  return (
    <div className='tw-flex tw-items-center tw-gap-3 tw-mb-4'>
      {indicator}
      <h3 className='tw-type-base'>{label}</h3>
    </div>
  );
}
